import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  tableWrap: {
    height: 'calc(100vh - 16rem)',
    overflow: 'auto',
    '@media all and (min-width: 620px) and (max-width: 1090px)': {
      height: 'calc(100vh - 23rem)',
      marginBottom: '1rem'
    },
    '@media all and (max-width: 620px)': {
      height: 'calc(100vh - 25rem)',
      marginBottom: '1rem'
    }
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  tableBody: { background: '#f9f9f9' },
  button: {
    marginLeft: '2%',
    height: '30px',
    width: '150px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgb(28, 132, 111)',
    color: '#fff',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgb(12, 171, 168)'
    },
    border: '2px solid #028B7E',
    borderRadius: '23px'
  }
}))

export default useStyles
